import React from 'react';
import { type GroupProps, Group, composeRenderProps } from 'react-aria-components';
import { tv } from 'tailwind-variants';
import { cn, focusRingVariants } from '~/shared/components/utils';

export const fieldBorderStyles = tv({
	extend: focusRingVariants,
	variants: {
		isFocusWithin: {
			false: 'border-gray-300 forced-colors:border-[ButtonBorder]'
		},
		isDisabled: {
			true: ''
		},
		isReadOnly: {
			true: ''
		}
	},
	compoundVariants: [
		{ isDisabled: true, class: 'border-gray-200 outline-0 ring-0 forced-colors:border-[GrayText]' },
		{ isReadOnly: true, class: 'border-gray-200 outline-0 ring-0 forced-colors:border-[GrayText]' }
	],
	defaultVariants: {
		intent: 'primary',
		isFocusVisible: false,
		isFocusWithin: false,
		isInvalid: false,
		isDisabled: false,
		isReadOnly: false
	}
});

const fieldGroupStyles = tv({
	extend: fieldBorderStyles,
	base: 'group flex items-center overflow-hidden rounded-md border bg-white forced-colors:bg-[Field]'
});

export function FieldGroup(props: GroupProps) {
	return (
		<Group {...props} className={composeRenderProps(props.className, (className, renderProps) => cn(fieldGroupStyles(renderProps), className))} />
	);
}
